import { FONT } from "@/styles/common";
import { Text } from "@chakra-ui/react";
import styled from "@emotion/styled";

export const CustomTitle = styled(Text)`
    flex-shrink: 0;
    color: ${({ theme }) => theme.COLOR.text[300]};
    ${FONT("notoSerif", 40, 500)};

    @media (max-width: ${({ theme }) => theme.MEDIA.mobile}) {
        ${FONT("notoSerif", 24, 500)}
    }
`;
